import { useState, useEffect } from 'react'
import api from '../services/api'
import { useSlug } from '../hooks/useSlug'
import { useMobile } from '../hooks/useMobile'
import FluxoProgresso from '../components/FluxoProgresso'

const SBG = { aberto:'#E6F1FB', tramitando:'#FAEEDA', pendente:'#fef9c3', concluido:'#EAF3DE', arquivado:'#F1EFE8' }
const SC  = { aberto:'#185FA5', tramitando:'#854F0B', pendente:'#854d0e', concluido:'#3B6D11', arquivado:'#5F5E5A' }
const SL  = { aberto:'Aguardando', tramitando:'Em andamento', pendente:'⚠️ Docs pendentes', concluido:'✅ Concluído', arquivado:'Arquivado' }
const IT  = { despacho:'💬', tramitacao:'➡️', pendencia:'⚠️', conclusao:'✅', arquivamento:'📦', abertura:'📂' }
const CLS = {
  obrigatorio: { label:'Obrigatório', bg:'#FCEBEB', cor:'#791F1F' },
  recomendado: { label:'Recomendado', bg:'#FAEEDA', cor:'#633806' },
  opcional:    { label:'Opcional',    bg:'#F1EFE8', cor:'#444441' },
}

function formatarCPF(v) { return v.replace(/\D/g,'').replace(/(\d{3})(\d)/,'$1.$2').replace(/(\d{3})(\d)/,'$1.$2').replace(/(\d{3})(\d{1,2})$/,'$1-$2').slice(0,14) }
function formatarCNPJ(v) { return v.replace(/\D/g,'').replace(/(\d{2})(\d)/,'$1.$2').replace(/(\d{3})(\d)/,'$1.$2').replace(/(\d{3})(\d)/,'$1/$2').replace(/(\d{4})(\d{1,2})$/,'$1-$2').slice(0,18) }

function LogoOrgao({ orgao }) {
  if (!orgao) return null
  return (
    <div style={{ display:'flex', alignItems:'center', gap:10 }}>
      {orgao.logo_url && <img src={orgao.logo_url} alt="Logo" style={{ height:36, objectFit:'contain' }} onError={e=>e.target.style.display='none'} />}
      <div>
        <div style={{ fontSize:13, fontWeight:600, color:'#111', lineHeight:1.2 }}>{orgao.nome}</div>
        {orgao.municipio && <div style={{ fontSize:11, color:'#9ca3af' }}>{orgao.municipio}/{orgao.estado}</div>}
      </div>
    </div>
  )
}

export default function Portal() {
  const SLUG = useSlug() || 'santarosa'
  const isMobile = useMobile()
  const [tela, setTela] = useState('login')
  const [contribuinte, setContribuinte] = useState(null)
  const [orgao, setOrgao] = useState(null)
  const [processos, setProcessos] = useState([])
  const [tipos, setTipos] = useState([])
  const [tipoSel, setTipoSel] = useState(null)
  const [campos, setCampos] = useState([])
  const [docsTipo, setDocsTipo] = useState([])
  const [respostas, setRespostas] = useState({})
  const [arquivosPorDoc, setArquivosPorDoc] = useState({})
  const [arquivosExtras, setArquivosExtras] = useState([])
  const [termoAceito, setTermoAceito] = useState(false)
  const [processoAtivo, setProcessoAtivo] = useState(null)
  const [docs, setDocs] = useState([])
  const [abaDetalhe, setAbaDetalhe] = useState('andamento')
  const [form, setForm] = useState({ tipoPessoa:'PF' })
  const [erro, setErro] = useState('')
  const [sucesso, setSucesso] = useState('')
  const [load, setLoad] = useState(false)
  const [modoLogin, setModoLogin] = useState(true)
  const [recursoForm, setRecursoForm] = useState({ justificativa:'' })
  const [recursoLoad, setRecursoLoad] = useState(false)
  const [mostrarRecurso, setMostrarRecurso] = useState(false)
  const [modoCadastro, setModoCadastro] = useState('login')
  const [anonForm, setAnonForm] = useState({ nome:'', cpf:'', email:'', telefone:'', tipoPessoa:'PF' })
  const [uploadPendenciaLoad, setUploadPendenciaLoad] = useState(false)
  const [uploadPendenciaDoc, setUploadPendenciaDoc] = useState(null)

  useEffect(() => {
    const token = localStorage.getItem(`pg_portal_token_${SLUG}`)
    const user = localStorage.getItem(`pg_portal_user_${SLUG}`)
    if (token && user) { setContribuinte(JSON.parse(user)); setTela('home'); carregarDados() }
    api.get(`/tipos/publico/${SLUG}`, { params:{ portal:'cidadao' } }).then(r => setTipos(r.data)).catch(() => {})
    api.get(`/configuracoes/publico/${SLUG}`).then(r => setOrgao(r.data)).catch(() => {})
  }, [])

  async function carregarDados() {
    try { const r = await api.get('/portal/meus-processos'); setProcessos(r.data) } catch {}
  }

  async function selecionarTipo(t) {
    setTipoSel(t); setCampos([]); setDocsTipo([]); setRespostas({})
    setArquivosPorDoc({}); setArquivosExtras([]); setTermoAceito(false)
    const [c, d] = await Promise.all([
      api.get(`/formulario/${t.id}`).then(r => r.data).catch(() => []),
      api.get(`/documentos-tipo/${t.id}`).then(r => r.data).catch(() => []),
    ])
    setCampos(c); setDocsTipo(d)
  }

  const set = (k,v) => setForm(f => ({...f,[k]:v}))

  async function fazerLogin(e) {
    e.preventDefault(); setErro(''); setLoad(true)
    try {
      const r = await api.post('/portal/login', { email:form.email, senha:form.senha, prefeitura_slug:SLUG })
      localStorage.setItem(`pg_portal_token_${SLUG}`, r.data.token)
      localStorage.setItem(`pg_portal_user_${SLUG}`, JSON.stringify(r.data.contribuinte))
      setContribuinte(r.data.contribuinte); setTela('home'); carregarDados(); setForm({ tipoPessoa:'PF' })
    } catch(e) { setErro(e.response?.data?.erro || 'E-mail ou senha inválidos') }
    finally { setLoad(false) }
  }

  async function fazerCadastro(e) {
    e.preventDefault(); setErro(''); setLoad(true)
    try {
      const docLimpo = form.cpf_cnpj?.replace(/\D/g,'')
      await api.post('/portal/cadastro', { ...form, cpf_cnpj:docLimpo, prefeitura_slug:SLUG })
      setSucesso('Cadastro realizado! Aguarde a aprovação para acessar.')
      setModoCadastro('login'); setForm({ tipoPessoa:'PF' })
      setTimeout(() => setSucesso(''), 6000)
    } catch(e) { setErro(e.response?.data?.erro || 'Erro ao cadastrar') }
    finally { setLoad(false) }
  }

  async function verDetalhe(p) {
    setProcessoAtivo(p); setDocs([]); setAbaDetalhe('andamento'); setTela('detalhe')
    try {
      const r = await api.get(`/portal/detalhe/${p.id}`)
      setProcessoAtivo(r.data)
      const rd = await api.get(`/portal/documentos/${p.id}`).catch(() => ({ data:[] }))
      setDocs(rd.data||[])
    } catch {}
  }

  async function abrirSolicitacao(e) {
    e.preventDefault(); setErro('')
    const faltando = docsTipo.filter(d => d.classificacao==='obrigatorio' && !arquivosPorDoc[d.id])
    if (faltando.length > 0) { setErro(`Anexe: ${faltando.map(d=>d.nome).join(', ')}`); return }
    if (tipoSel?.termo_declaracao && !termoAceito) { setErro('Aceite o termo para continuar.'); return }
    setLoad(true)
    try {
      const dadosFormulario = {}
      campos.forEach(c => { if(respostas[c.id]) dadosFormulario[c.label] = respostas[c.id] })
      const dadosReq = contribuinte?.anonimo ? { req_nome:contribuinte.nome, req_cpf_cnpj:contribuinte.cpf_cnpj, req_email:contribuinte.email, req_telefone:contribuinte.telefone } : {}
      const res = await api.post(contribuinte?.anonimo ? '/processos/abrir-anonimo' : '/portal/abrir-processo', {
        tipo_id: tipoSel?.id, assunto: tipoSel?.nome || form.assunto,
        dados_formulario: dadosFormulario, termo_aceito: termoAceito
      })
      const processo = res.data
      for (const [docTipoId, arquivo] of Object.entries(arquivosPorDoc)) {
        const fd = new FormData(); fd.append('arquivo', arquivo); fd.append('documento_tipo_id', docTipoId)
        try { await api.post(`/portal/upload/${processo.id}`, fd, { headers:{'Content-Type':'multipart/form-data'} }) } catch {}
      }
      setSucesso('Solicitação enviada!'); setTela('home'); carregarDados()
      setTipoSel(null); setCampos([]); setDocsTipo([]); setRespostas({})
      setArquivosPorDoc({}); setArquivosExtras([]); setTermoAceito(false); setForm({ tipoPessoa:'PF' })
    } catch(e) { setErro(e.response?.data?.erro || 'Erro ao abrir solicitação') }
    finally { setLoad(false) }
  }

  async function interporRecurso(processoId) {
    if (!recursoForm.justificativa) return
    setRecursoLoad(true)
    try {
      await api.post(`/processos/${processoId}/recurso`, recursoForm)
      setSucesso('Recurso interposto com sucesso! Aguarde a análise.')
      setMostrarRecurso(false)
      setRecursoForm({ justificativa:'' })
      carregarDados()
      setTimeout(() => setSucesso(''), 5000)
    } catch(e) { alert(e.response?.data?.erro || 'Erro ao interpor recurso') }
    finally { setRecursoLoad(false) }
  }

  function sair() {
    localStorage.removeItem(`pg_portal_token_${SLUG}`)
    localStorage.removeItem(`pg_portal_user_${SLUG}`)
    setContribuinte(null); setTela('login'); setForm({ tipoPessoa:'PF' })
  }

  function renderCampo(campo) {
    const val = respostas[campo.id]||''
    const setVal = v => setRespostas(r => ({...r,[campo.id]:v}))
    const style = { width:'100%', padding:'11px 12px', border:'1px solid #d1d5db', borderRadius:8, fontSize:14, boxSizing:'border-box' }
    if(campo.tipo_campo==='select') {
      const opcoes = Array.isArray(campo.opcoes)?campo.opcoes:JSON.parse(campo.opcoes||'[]')
      return <select value={val} onChange={e=>setVal(e.target.value)} required={campo.obrigatorio} style={style}>
        <option value="">Selecione...</option>
        {opcoes.map(o => <option key={o} value={o}>{o}</option>)}
      </select>
    }
    if(campo.tipo_campo==='textarea') return <textarea value={val} onChange={e=>setVal(e.target.value)} required={campo.obrigatorio} placeholder={campo.placeholder||''} style={{...style,minHeight:90,resize:'vertical'}} />
    if(campo.tipo_campo==='checkbox') return <label style={{ display:'flex', alignItems:'center', gap:10, fontSize:14 }}><input type="checkbox" checked={!!val} onChange={e=>setVal(e.target.checked?'sim':'')} style={{ width:20, height:20 }} />{campo.placeholder||'Sim'}</label>
    return <input type={campo.tipo_campo||'text'} value={val} onChange={e=>setVal(e.target.value)} required={campo.obrigatorio} placeholder={campo.placeholder||''} style={style} />
  }

  const p = isMobile ? 16 : 24
  const inpStyle = { width:'100%', padding:'12px 14px', border:'1.5px solid #e5e7eb', borderRadius:10, fontSize:15, boxSizing:'border-box', WebkitAppearance:'none', outline:'none', fontFamily:'inherit' }

  // Wrapper das telas internas (home, novo, detalhe) — mantém fundo claro
  const wrap = children => (
    <div style={{ minHeight:'100vh', background:'#f0f4f8', fontFamily:"'Inter', system-ui, sans-serif" }}>
      <div style={{ background:'white', borderBottom:'1px solid #e5e7eb', padding:`12px ${p}px`, display:'flex', alignItems:'center', justifyContent:'space-between', position:'sticky', top:0, zIndex:10 }}>
        <LogoOrgao orgao={orgao} />
        {contribuinte && tela!=='login' && (
          <div style={{ display:'flex', alignItems:'center', gap:8 }}>
            {tela!=='home' && <button onClick={() => setTela('home')} style={{ padding:'6px 10px', background:'#f3f4f6', border:'none', borderRadius:6, fontSize:12, cursor:'pointer' }}>← Início</button>}
            <button onClick={sair} style={{ padding:'6px 10px', background:'#f3f4f6', border:'none', borderRadius:6, fontSize:12, cursor:'pointer' }}>Sair</button>
          </div>
        )}
      </div>
      <div style={{ maxWidth:680, margin:'0 auto', padding:`${p}px ${p}px` }}>
        {sucesso && <div style={{ background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:8, padding:12, fontSize:13, color:'#15803d', marginBottom:16 }}>{sucesso}</div>}
        {children}
      </div>
    </div>
  )

  // ─── LOGIN ───────────────────────────────────────────────────────────────
  if(tela==='login') return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0d3d6b 0%, #185FA5 55%, #1e7bc4 100%)',
      fontFamily: "'Inter', system-ui, sans-serif",
      padding: isMobile ? '20px 16px' : '40px 16px',
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* Círculos decorativos */}
      <div style={{ position:'absolute', top:'-80px', right:'-80px', width:'320px', height:'320px', borderRadius:'50%', background:'rgba(255,255,255,0.05)', pointerEvents:'none' }} />
      <div style={{ position:'absolute', bottom:'-60px', left:'-60px', width:'240px', height:'240px', borderRadius:'50%', background:'rgba(255,255,255,0.04)', pointerEvents:'none' }} />

      <div style={{ maxWidth: 460, margin: '0 auto', position: 'relative', zIndex: 1 }}>
        {/* Cabeçalho com logo do órgão */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          {orgao?.logo_url ? (
            <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:10 }}>
              <div style={{ background:'rgba(255,255,255,0.15)', backdropFilter:'blur(8px)', border:'1px solid rgba(255,255,255,0.2)', borderRadius:16, padding:'12px 20px', display:'inline-flex', alignItems:'center', gap:12 }}>
                <img src={orgao.logo_url} alt="Logo" style={{ height:40, objectFit:'contain' }} onError={e=>e.target.style.display='none'} />
                <div style={{ textAlign:'left' }}>
                  <div style={{ fontSize:14, fontWeight:700, color:'white' }}>{orgao.nome}</div>
                  {orgao.municipio && <div style={{ fontSize:11, color:'rgba(255,255,255,0.7)' }}>{orgao.municipio}/{orgao.estado}</div>}
                </div>
              </div>
            </div>
          ) : (
            <>
              <div style={{ display:'inline-flex', alignItems:'center', justifyContent:'center', width:52, height:52, borderRadius:16, background:'rgba(255,255,255,0.15)', backdropFilter:'blur(8px)', marginBottom:12, border:'1px solid rgba(255,255,255,0.2)' }}>
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                  <rect x="2" y="2" width="10" height="10" rx="2" fill="white" fillOpacity="0.9"/>
                  <rect x="14" y="2" width="10" height="10" rx="2" fill="white" fillOpacity="0.6"/>
                  <rect x="2" y="14" width="10" height="10" rx="2" fill="white" fillOpacity="0.6"/>
                  <rect x="14" y="14" width="10" height="10" rx="2" fill="white" fillOpacity="0.9"/>
                </svg>
              </div>
              <div style={{ fontSize:26, fontWeight:700, color:'white', letterSpacing:'-0.5px' }}>
                Proto<span style={{ color:'#90c8f8' }}>Gov</span>
              </div>
            </>
          )}
          <div style={{ fontSize:13, color:'rgba(255,255,255,0.65)', marginTop:8 }}>
            Portal do Cidadão
          </div>
        </div>

        {/* Abas de modo */}
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:6, marginBottom:16 }}>
          {[
            ['login','🔑','Entrar'],
            ['cadastro','📝','Cadastrar'],
            ['anonimo','👤','Sem cadastro'],
          ].map(([k,icon,label]) => (
            <button key={k} onClick={()=>{setModoCadastro(k);setErro('')}} style={{
              padding:'10px 6px',
              border: modoCadastro===k ? '2px solid rgba(255,255,255,0.8)' : '2px solid rgba(255,255,255,0.2)',
              borderRadius: 12,
              fontSize: 12,
              cursor: 'pointer',
              background: modoCadastro===k ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.07)',
              color: modoCadastro===k ? 'white' : 'rgba(255,255,255,0.6)',
              fontWeight: modoCadastro===k ? 600 : 400,
              textAlign: 'center',
              backdropFilter: 'blur(4px)',
              transition: 'all 0.2s',
            }}>
              <div style={{ fontSize:16, marginBottom:2 }}>{icon}</div>
              {label}
            </button>
          ))}
        </div>

        {/* Card */}
        <div style={{ background:'white', borderRadius:20, padding:isMobile?24:32, boxShadow:'0 24px 60px rgba(0,0,0,0.25)' }}>
          {sucesso && <div style={{ background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:10, padding:12, fontSize:13, color:'#15803d', marginBottom:16 }}>{sucesso}</div>}

          {modoCadastro==='login' ? (
            <form onSubmit={fazerLogin}>
              <div style={{ fontSize:16, fontWeight:600, color:'#111827', marginBottom:4 }}>Bem-vindo de volta</div>
              <div style={{ fontSize:13, color:'#9ca3af', marginBottom:24 }}>Entre com seu e-mail e senha cadastrados.</div>
              {[['email','E-mail','seu@email.com','email'],['senha','Senha','••••••••','password']].map(([k,l,ph,t])=>(
                <div key={k} style={{ marginBottom:16 }}>
                  <label style={{ display:'block', fontSize:12, fontWeight:600, marginBottom:6, color:'#374151', textTransform:'uppercase', letterSpacing:'0.5px' }}>{l}</label>
                  <input type={t} value={form[k]||''} onChange={e=>set(k,e.target.value)} required placeholder={ph}
                    style={inpStyle}
                    onFocus={e=>e.target.style.borderColor='#185FA5'}
                    onBlur={e=>e.target.style.borderColor='#e5e7eb'} />
                </div>
              ))}
              {erro && <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:10, padding:'10px 14px', fontSize:13, color:'#dc2626', marginBottom:16, display:'flex', alignItems:'center', gap:8 }}><span>⚠️</span>{erro}</div>}
              <button type="submit" disabled={load} style={{ width:'100%', padding:13, background:load?'#93c5fd':'linear-gradient(135deg,#185FA5,#1e7bc4)', color:'white', border:'none', borderRadius:10, fontSize:15, cursor:load?'default':'pointer', fontWeight:600, boxShadow:load?'none':'0 4px 14px rgba(24,95,165,0.4)', fontFamily:'inherit' }}>
                {load?'Entrando...':'Entrar →'}
              </button>
            </form>

          ) : modoCadastro==='anonimo' ? (
            <div>
              <div style={{ fontSize:16, fontWeight:600, color:'#111827', marginBottom:4 }}>Continuar sem cadastro</div>
              <div style={{ fontSize:13, color:'#9ca3af', marginBottom:20 }}>Preencha seus dados para abrir uma solicitação. Acompanhe pelo número do protocolo.</div>
              <div style={{ display:'flex', gap:8, marginBottom:16 }}>
                {[['PF','👤 Pessoa Física'],['PJ','🏢 Empresa']].map(([k,l])=>(
                  <button key={k} type="button" onClick={()=>setAnonForm(f=>({...f,tipoPessoa:k}))} style={{ flex:1, padding:'10px 8px', border:`2px solid ${anonForm.tipoPessoa===k?'#185FA5':'#e5e7eb'}`, borderRadius:8, fontSize:13, cursor:'pointer', background:anonForm.tipoPessoa===k?'#E6F1FB':'white', color:anonForm.tipoPessoa===k?'#185FA5':'#374151', fontWeight:anonForm.tipoPessoa===k?600:400 }}>{l}</button>
                ))}
              </div>
              {[['nome','Nome completo *','Seu nome'],['cpf','CPF/CNPJ *',anonForm.tipoPessoa==='PF'?'000.000.000-00':'00.000.000/0000-00'],['email','E-mail','seu@email.com'],['telefone','Telefone','(00) 00000-0000']].map(([k,l,ph])=>(
                <div key={k} style={{ marginBottom:14 }}>
                  <label style={{ display:'block', fontSize:12, fontWeight:600, marginBottom:6, color:'#374151', textTransform:'uppercase', letterSpacing:'0.5px' }}>{l}</label>
                  <input value={anonForm[k]||''} onChange={e=>setAnonForm(f=>({...f,[k]:e.target.value}))} placeholder={ph}
                    style={inpStyle}
                    onFocus={e=>e.target.style.borderColor='#185FA5'}
                    onBlur={e=>e.target.style.borderColor='#e5e7eb'} />
                </div>
              ))}
              {erro && <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:10, padding:'10px 14px', fontSize:13, color:'#dc2626', marginBottom:16, display:'flex', alignItems:'center', gap:8 }}><span>⚠️</span>{erro}</div>}
              <button onClick={()=>{
                if(!anonForm.nome||!anonForm.cpf){setErro('Nome e CPF são obrigatórios');return}
                setErro('')
                setContribuinte({ nome:anonForm.nome, cpf_cnpj:anonForm.cpf, email:anonForm.email, telefone:anonForm.telefone, anonimo:true })
                setTela('novo')
              }} style={{ width:'100%', padding:13, background:'linear-gradient(135deg,#185FA5,#1e7bc4)', color:'white', border:'none', borderRadius:10, fontSize:15, cursor:'pointer', fontWeight:600, boxShadow:'0 4px 14px rgba(24,95,165,0.4)', fontFamily:'inherit' }}>
                Continuar →
              </button>
              <div style={{ fontSize:12, color:'#9ca3af', marginTop:12, textAlign:'center' }}>Você receberá um número de protocolo para acompanhar sua solicitação.</div>
            </div>

          ) : (
            <form onSubmit={fazerCadastro}>
              <div style={{ fontSize:16, fontWeight:600, color:'#111827', marginBottom:4 }}>Criar conta</div>
              <div style={{ fontSize:13, color:'#9ca3af', marginBottom:20 }}>Após o cadastro, aguarde a aprovação do órgão.</div>
              <div style={{ display:'flex', gap:8, marginBottom:16 }}>
                {[['PF','👤 Pessoa Física'],['PJ','🏢 Empresa']].map(([k,l]) => (
                  <button key={k} type="button" onClick={()=>set('tipoPessoa',k)} style={{ flex:1, padding:'10px 8px', border:`2px solid ${form.tipoPessoa===k?'#185FA5':'#e5e7eb'}`, borderRadius:8, fontSize:13, cursor:'pointer', background:form.tipoPessoa===k?'#E6F1FB':'white', color:form.tipoPessoa===k?'#185FA5':'#374151', fontWeight:form.tipoPessoa===k?600:400 }}>{l}</button>
                ))}
              </div>
              {form.tipoPessoa==='PJ' ? <>
                {[['razao_social','Razão social *','Nome da empresa'],['cpf_cnpj','CNPJ *','00.000.000/0000-00'],['responsavel_legal','Responsável legal *','Nome do responsável'],['nome','Nome para exibição *','Como aparece no sistema']].map(([k,l,ph])=>(
                  <div key={k} style={{ marginBottom:14 }}>
                    <label style={{ display:'block', fontSize:12, fontWeight:600, marginBottom:6, color:'#374151', textTransform:'uppercase', letterSpacing:'0.5px' }}>{l}</label>
                    <input value={form[k]||''} onChange={e=>set(k,k==='cpf_cnpj'?formatarCNPJ(e.target.value):e.target.value)} required={l.includes('*')} placeholder={ph} style={inpStyle} onFocus={e=>e.target.style.borderColor='#185FA5'} onBlur={e=>e.target.style.borderColor='#e5e7eb'} />
                  </div>
                ))}
              </> : <>
                {[['nome','Nome completo *','Seu nome'],['cpf_cnpj','CPF *','000.000.000-00']].map(([k,l,ph])=>(
                  <div key={k} style={{ marginBottom:14 }}>
                    <label style={{ display:'block', fontSize:12, fontWeight:600, marginBottom:6, color:'#374151', textTransform:'uppercase', letterSpacing:'0.5px' }}>{l}</label>
                    <input value={form[k]||''} onChange={e=>set(k,k==='cpf_cnpj'?formatarCPF(e.target.value):e.target.value)} required placeholder={ph} style={inpStyle} onFocus={e=>e.target.style.borderColor='#185FA5'} onBlur={e=>e.target.style.borderColor='#e5e7eb'} />
                  </div>
                ))}
              </>}
              {[['email','E-mail *','seu@email.com','email'],['telefone','Telefone','(00) 00000-0000','tel'],['senha','Senha *','Mínimo 6 caracteres','password'],['endereco','Endereço','Rua, número, bairro','text']].map(([k,l,ph,t])=>(
                <div key={k} style={{ marginBottom:14 }}>
                  <label style={{ display:'block', fontSize:12, fontWeight:600, marginBottom:6, color:'#374151', textTransform:'uppercase', letterSpacing:'0.5px' }}>{l}</label>
                  <input type={t} value={form[k]||''} onChange={e=>set(k,e.target.value)} required={l.includes('*')} placeholder={ph} style={inpStyle} onFocus={e=>e.target.style.borderColor='#185FA5'} onBlur={e=>e.target.style.borderColor='#e5e7eb'} />
                </div>
              ))}
              {erro && <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:10, padding:'10px 14px', fontSize:13, color:'#dc2626', marginBottom:16, display:'flex', alignItems:'center', gap:8 }}><span>⚠️</span>{erro}</div>}
              <button type="submit" disabled={load} style={{ width:'100%', padding:13, background:load?'#93c5fd':'linear-gradient(135deg,#185FA5,#1e7bc4)', color:'white', border:'none', borderRadius:10, fontSize:15, cursor:load?'default':'pointer', fontWeight:600, boxShadow:load?'none':'0 4px 14px rgba(24,95,165,0.4)', fontFamily:'inherit' }}>
                {load?'Cadastrando...':'Criar conta →'}
              </button>
              <div style={{ fontSize:12, color:'#9ca3af', marginTop:12, textAlign:'center' }}>Aguarde aprovação do órgão após o cadastro.</div>
            </form>
          )}
        </div>

        <div style={{ textAlign:'center', marginTop:20 }}>
          <a href="/consulta" style={{ fontSize:13, color:'rgba(255,255,255,0.65)', textDecoration:'none' }}>Consultar protocolo →</a>
        </div>
      </div>
    </div>
  )

  // ─── HOME ────────────────────────────────────────────────────────────────
  const pendentes = processos.filter(p=>p.status==='pendente').length
  if(tela==='home') return wrap(<>
    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
      <div>
        <div style={{ fontSize:16, fontWeight:500 }}>Olá, {contribuinte?.nome?.split(' ')[0]}!</div>
        <div style={{ fontSize:12, color:'#9ca3af' }}>Suas solicitações</div>
      </div>
      <button onClick={() => { setTela('novo'); setErro(''); setTipoSel(null) }} style={{ padding:'10px 16px', background:'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:14, cursor:'pointer', fontWeight:500 }}>+ Nova</button>
    </div>
    {pendentes > 0 && (
      <div style={{ background:'#fef9c3', border:'1px solid #fef08a', borderRadius:10, padding:'12px 14px', marginBottom:16 }}>
        <div style={{ fontSize:13, color:'#854d0e' }}>⚠️ <strong>{pendentes}</strong> solicitaç{pendentes>1?'ões':'ão'} com documentos pendentes.</div>
      </div>
    )}
    <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', overflow:'hidden' }}>
      {processos.length===0
        ? <div style={{ padding:40, textAlign:'center' }}>
            <div style={{ fontSize:40, marginBottom:12 }}>📋</div>
            <div style={{ fontSize:15, fontWeight:500, marginBottom:8 }}>Nenhuma solicitação ainda</div>
            <button onClick={() => setTela('novo')} style={{ padding:'12px 24px', background:'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:14, cursor:'pointer' }}>+ Fazer solicitação</button>
          </div>
        : processos.map((p,i)=>(
          <div key={p.id} onClick={() => verDetalhe(p)} style={{ display:'flex', alignItems:'center', gap:12, padding:'16px', borderBottom:i<processos.length-1?'1px solid #f3f4f6':'none', cursor:'pointer' }}>
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ fontSize:14, fontWeight:500, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{p.assunto}</div>
              <div style={{ fontSize:12, color:'#9ca3af', marginTop:3 }}>{new Date(p.aberto_em).toLocaleDateString('pt-BR')}</div>
              <div style={{ display:'flex', alignItems:'center', gap:8, marginTop:4 }}>
                <span style={{ background:SBG[p.status]||'#f3f4f6', color:SC[p.status]||'#374151', padding:'2px 8px', borderRadius:99, fontSize:11 }}>{SL[p.status]||p.status}</span>
                <FluxoProgresso processo={p} compact />
              </div>
            </div>
            <span style={{ color:'#d1d5db', fontSize:20 }}>›</span>
          </div>
        ))
      }
    </div>
  </>)

  // ─── NOVO ────────────────────────────────────────────────────────────────
  if(tela==='novo') return wrap(
    <form onSubmit={abrirSolicitacao}>
      <div style={{ fontSize:16, fontWeight:500, marginBottom:4 }}>Nova solicitação</div>
      <div style={{ fontSize:13, color:'#9ca3af', marginBottom:16 }}>Selecione o tipo de solicitação</div>
      <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:16, marginBottom:16 }}>
        <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
          {tipos.map(t => (
            <div key={t.id} onClick={() => selecionarTipo(t)} style={{ border:`2px solid ${tipoSel?.id===t.id?'#185FA5':'#e5e7eb'}`, borderRadius:10, padding:'12px 14px', cursor:'pointer', background:tipoSel?.id===t.id?'#E6F1FB':'white' }}>
              <div style={{ fontSize:14, fontWeight:500, color:tipoSel?.id===t.id?'#185FA5':'#111' }}>{t.nome}</div>
              {t.descricao && <div style={{ fontSize:12, color:'#9ca3af', marginTop:2 }}>{t.descricao}</div>}
              <div style={{ display:'flex', gap:8, marginTop:4, flexWrap:'wrap' }}>
                {t.prazo_dias && <span style={{ fontSize:11, color:'#6b7280' }}>⏱ {t.prazo_dias} dias</span>}
                {t.requer_aprovacao && <span style={{ fontSize:11, color:'#854d0e' }}>⏳ Requer aprovação</span>}
              </div>
            </div>
          ))}
        </div>
      </div>

      {tipoSel && <>
        {campos.length > 0 && (
          <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:16, marginBottom:16 }}>
            <div style={{ fontSize:13, fontWeight:500, marginBottom:14 }}>Dados da solicitação</div>
            {campos.map(c => (
              <div key={c.id} style={{ marginBottom:16 }}>
                <label style={{ display:'block', fontSize:13, fontWeight:500, marginBottom:6, color:'#374151' }}>
                  {c.label}{c.obrigatorio && <span style={{ color:'#dc2626' }}> *</span>}
                </label>
                {renderCampo(c)}
              </div>
            ))}
          </div>
        )}

        {docsTipo.length > 0 && (
          <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', overflow:'hidden', marginBottom:16 }}>
            <div style={{ padding:'14px 16px', borderBottom:'1px solid #f3f4f6', fontSize:13, fontWeight:500 }}>📎 Documentos necessários</div>
            {docsTipo.map((d,i) => {
              const cls = CLS[d.classificacao]||CLS.obrigatorio
              const arquivo = arquivosPorDoc[d.id]
              return (
                <div key={d.id} style={{ padding:'14px 16px', borderBottom:i<docsTipo.length-1?'1px solid #f9fafb':'none' }}>
                  <div style={{ display:'flex', alignItems:'flex-start', gap:10, marginBottom:8 }}>
                    {arquivo
                      ? <div style={{ width:22, height:22, borderRadius:'50%', background:'#EAF3DE', border:'2px solid #3B6D11', display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, color:'#3B6D11', flexShrink:0 }}>✓</div>
                      : <div style={{ width:22, height:22, borderRadius:'50%', border:`2px solid ${d.classificacao==='obrigatorio'?'#fecaca':'#d1d5db'}`, background:'white', flexShrink:0 }} />
                    }
                    <div style={{ flex:1 }}>
                      <div style={{ fontSize:14, fontWeight:500 }}>{d.nome}</div>
                      <span style={{ background:cls.bg, color:cls.cor, fontSize:11, padding:'1px 7px', borderRadius:99 }}>{cls.label}</span>
                    </div>
                  </div>
                  {d.observacao && <div style={{ fontSize:13, color:'#6b7280', marginBottom:8, paddingLeft:32 }}>💡 {d.observacao}</div>}
                  <div style={{ paddingLeft:32 }}>
                    {arquivo ? (
                      <div style={{ display:'flex', alignItems:'center', gap:8, background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:8, padding:'8px 12px' }}>
                        <span style={{ fontSize:13, color:'#15803d', flex:1 }}>✅ {arquivo.name}</span>
                        <button type="button" onClick={() => setArquivosPorDoc(a => { const n={...a}; delete n[d.id]; return n })} style={{ background:'none', border:'none', color:'#dc2626', cursor:'pointer', padding:'4px 8px' }}>Remover</button>
                      </div>
                    ) : (
                      <button type="button" onClick={() => { const i=document.createElement('input');i.type='file';i.accept='.pdf,.jpg,.jpeg,.png';i.onchange=e=>{if(e.target.files[0])setArquivosPorDoc(a=>({...a,[d.id]:e.target.files[0]}))};i.click() }}
                        style={{ width:'100%', padding:'10px', border:`1.5px dashed ${d.classificacao==='obrigatorio'?'#fca5a5':'#d1d5db'}`, borderRadius:8, fontSize:13, cursor:'pointer', background:'#fafafa' }}>
                        📎 Anexar documento
                      </button>
                    )}
                  </div>
                </div>
              )
            })}
          </div>
        )}

        {tipoSel.termo_declaracao && (
          <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:16, marginBottom:16 }}>
            <div style={{ fontSize:14, fontWeight:500, marginBottom:10 }}>{tipoSel.termo_titulo||'Termo'}</div>
            <div style={{ background:'#f9fafb', borderRadius:8, padding:14, fontSize:13, lineHeight:1.7, marginBottom:14, maxHeight:180, overflowY:'auto', border:'1px solid #e5e7eb' }}>{tipoSel.termo_declaracao}</div>
            <label style={{ display:'flex', alignItems:'flex-start', gap:12, cursor:'pointer' }}>
              <input type="checkbox" checked={termoAceito} onChange={e=>setTermoAceito(e.target.checked)} style={{ width:22, height:22, marginTop:2, flexShrink:0 }} />
              <span style={{ fontSize:14, lineHeight:1.5 }}>Li e concordo com os termos acima.</span>
            </label>
          </div>
        )}

        {campos.length === 0 && (
          <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:16, marginBottom:16 }}>
            <label style={{ display:'block', fontSize:13, fontWeight:500, marginBottom:8 }}>Descrição *</label>
            <textarea value={form.assunto||''} onChange={e=>set('assunto',e.target.value)} required placeholder="Descreva sua solicitação..."
              style={{ width:'100%', padding:'12px', border:'1px solid #d1d5db', borderRadius:8, fontSize:14, minHeight:100, resize:'vertical', boxSizing:'border-box' }} />
          </div>
        )}

        {erro && <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:12, fontSize:13, color:'#dc2626', marginBottom:14 }}>{erro}</div>}
        <div style={{ display:'flex', flexDirection:isMobile?'column':'row', gap:10 }}>
          <button type="submit" disabled={load} style={{ flex:1, padding:14, background:'#185FA5', color:'white', border:'none', borderRadius:10, fontSize:16, cursor:'pointer', fontWeight:500 }}>
            {load?'⏳ Enviando...':'Enviar solicitação'}
          </button>
          <button type="button" onClick={() => { setTipoSel(null); setCampos([]); setDocsTipo([]) }} style={{ padding:'14px 20px', border:'1px solid #d1d5db', borderRadius:10, fontSize:14, cursor:'pointer', background:'white' }}>Cancelar</button>
        </div>
      </>}
    </form>
  )

  // ─── DETALHE ─────────────────────────────────────────────────────────────
  return wrap(<>
    {processoAtivo && <>
      <FluxoProgresso processo={processoAtivo} />

      <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:16, marginBottom:16 }}>
        <div style={{ fontFamily:'monospace', fontSize:13, color:'#185FA5', fontWeight:700, marginBottom:4 }}>{processoAtivo.numero}</div>
        <div style={{ fontSize:16, fontWeight:600, marginBottom:12 }}>{processoAtivo.assunto}</div>
        <span style={{ background:SBG[processoAtivo.status]||'#f3f4f6', color:SC[processoAtivo.status]||'#374151', padding:'4px 12px', borderRadius:99, fontSize:13, fontWeight:500 }}>
          {SL[processoAtivo.status]||processoAtivo.status}
        </span>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginTop:14 }}>
          {[['Aberto em',new Date(processoAtivo.aberto_em).toLocaleDateString('pt-BR')],['Setor',processoAtivo.setor_atual_nome||'—'],['Prazo',processoAtivo.prazo_em?new Date(processoAtivo.prazo_em).toLocaleDateString('pt-BR'):'—'],['Tipo',processoAtivo.tipo_nome||'—']].map(([l,v])=>(
            <div key={l}><div style={{ fontSize:11, color:'#9ca3af' }}>{l}</div><div style={{ fontSize:13, fontWeight:500, marginTop:1 }}>{v}</div></div>
          ))}
        </div>
      </div>

      {processoAtivo.status === 'pendente' && (
        <div style={{ background:'#fef9c3', border:'1px solid #fef08a', borderRadius:12, padding:16, marginBottom:16 }}>
          <div style={{ fontSize:14, fontWeight:500, color:'#854d0e', marginBottom:4 }}>⚠️ Documentos pendentes</div>
          <div style={{ fontSize:13, color:'#374151', marginBottom:12 }}>
            {processoAtivo.tramitacoes?.filter(t=>t.tipo==='pendencia').slice(-1)[0]?.descricao || 'O setor solicitou documentos adicionais.'}
          </div>
          {uploadPendenciaDoc ? (
            <div style={{ display:'flex', alignItems:'center', gap:8, background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:8, padding:'8px 12px', marginBottom:8 }}>
              <span style={{ flex:1, fontSize:13, color:'#15803d' }}>✅ {uploadPendenciaDoc.name}</span>
              <button onClick={()=>setUploadPendenciaDoc(null)} style={{ background:'none', border:'none', color:'#dc2626', cursor:'pointer' }}>✕</button>
            </div>
          ) : (
            <button onClick={()=>{const i=document.createElement('input');i.type='file';i.accept='.pdf,.jpg,.jpeg,.png';i.onchange=e=>{if(e.target.files[0])setUploadPendenciaDoc(e.target.files[0])};i.click()}}
              style={{ width:'100%', padding:10, border:'1.5px dashed #fca5a5', borderRadius:8, fontSize:13, cursor:'pointer', background:'#fafafa', marginBottom:8 }}>
              📎 Anexar documento
            </button>
          )}
          <button onClick={async()=>{
            if(!uploadPendenciaDoc){alert('Anexe um documento');return}
            setUploadPendenciaLoad(true)
            try {
              const fd=new FormData();fd.append('arquivo',uploadPendenciaDoc)
              await api.post(`/portal/upload/${processoAtivo.id}`,fd,{headers:{'Content-Type':'multipart/form-data'}})
              setUploadPendenciaDoc(null)
              alert('Documento enviado! O setor será notificado.')
              verDetalhe(processoAtivo)
            } catch { alert('Erro ao enviar') }
            finally { setUploadPendenciaLoad(false) }
          }} disabled={uploadPendenciaLoad||!uploadPendenciaDoc}
            style={{ width:'100%', padding:10, background:'#854d0e', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:500 }}>
            {uploadPendenciaLoad?'Enviando...':'Enviar documento'}
          </button>
        </div>
      )}

      {(processoAtivo.status === 'arquivado' || processoAtivo.status === 'concluido') &&
       processoAtivo.recurso_status !== 'aprovado' && processoAtivo.recurso_status !== 'negado' && (
        <div style={{ background:'#FCEBEB', border:'1px solid #F5A5A5', borderRadius:12, padding:16, marginBottom:16 }}>
          <div style={{ fontSize:14, fontWeight:500, color:'#791F1F', marginBottom:4 }}>⚖️ Deseja recorrer desta decisão?</div>
          {processoAtivo.recurso_status === 'pendente' ? (
            <div style={{ fontSize:13, color:'#374151' }}>Seu recurso está sendo analisado. Aguarde a resposta.</div>
          ) : (
            <>
              <div style={{ fontSize:13, color:'#374151', marginBottom:10 }}>
                Se você discorda da decisão, pode interpor recurso.
                {processoAtivo.prazo_recurso_em && (
                  <span style={{ color:'#791F1F', fontWeight:500 }}> Prazo: {new Date(processoAtivo.prazo_recurso_em).toLocaleDateString('pt-BR')}</span>
                )}
              </div>
              {!mostrarRecurso ? (
                <button onClick={() => setMostrarRecurso(true)}
                  style={{ padding:'8px 16px', background:'#791F1F', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:500 }}>
                  ⚖️ Interpor recurso
                </button>
              ) : (
                <div>
                  <textarea value={recursoForm.justificativa} onChange={e=>setRecursoForm(f=>({...f,justificativa:e.target.value}))}
                    placeholder="Descreva os motivos do seu recurso..."
                    style={{ width:'100%', padding:'10px', border:'1px solid #fecaca', borderRadius:8, fontSize:13, minHeight:80, resize:'vertical', boxSizing:'border-box', marginBottom:8 }} />
                  <div style={{ display:'flex', gap:8 }}>
                    <button onClick={() => interporRecurso(processoAtivo.id)} disabled={recursoLoad}
                      style={{ flex:1, padding:'10px', background:'#791F1F', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:500 }}>
                      {recursoLoad ? 'Enviando...' : 'Confirmar recurso'}
                    </button>
                    <button onClick={() => { setMostrarRecurso(false); setRecursoForm({ justificativa:'' }) }}
                      style={{ padding:'10px 14px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, cursor:'pointer', background:'white' }}>
                      Cancelar
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      )}

      <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', overflow:'hidden' }}>
        <div style={{ display:'flex', borderBottom:'1px solid #f3f4f6' }}>
          {[{key:'andamento',label:'Andamento'},{key:'documentos',label:`Docs${docs.length>0?` (${docs.length})`:''}`}].map(a=>(
            <div key={a.key} onClick={()=>setAbaDetalhe(a.key)} style={{ flex:1, padding:'14px 16px', textAlign:'center', fontSize:14, cursor:'pointer', fontWeight:abaDetalhe===a.key?500:400, color:abaDetalhe===a.key?'#185FA5':'#9ca3af', borderBottom:abaDetalhe===a.key?'2px solid #185FA5':'2px solid transparent' }}>{a.label}</div>
          ))}
        </div>
        <div style={{ padding:16 }}>
          {abaDetalhe==='andamento' && (
            (!processoAtivo.tramitacoes||processoAtivo.tramitacoes.length===0)
              ? <div style={{ textAlign:'center', padding:24, color:'#9ca3af', fontSize:14 }}>Nenhum andamento ainda.</div>
              : processoAtivo.tramitacoes?.map((t,i,arr)=>(
                <div key={i} style={{ display:'flex', gap:12, paddingBottom:16, position:'relative' }}>
                  {i<arr.length-1&&<div style={{ position:'absolute', left:14, top:30, bottom:0, width:2, background:'#e5e7eb' }} />}
                  <div style={{ width:28, height:28, borderRadius:'50%', background:'#E6F1FB', border:'2px solid #B5D4F4', display:'flex', alignItems:'center', justifyContent:'center', fontSize:13, flexShrink:0 }}>{IT[t.tipo]||'📋'}</div>
                  <div style={{ flex:1 }}>
                    <div style={{ fontSize:14, lineHeight:1.5 }}>{t.descricao}</div>
                    <div style={{ fontSize:12, color:'#9ca3af', marginTop:4 }}>{new Date(t.data_hora).toLocaleString('pt-BR')}</div>
                  </div>
                </div>
              ))
          )}
          {abaDetalhe==='documentos' && (
            docs.length===0
              ? <div style={{ textAlign:'center', padding:24, color:'#9ca3af', fontSize:14 }}>Nenhum documento enviado.</div>
              : docs.map((d,i)=>(
                <div key={d.id||i} style={{ display:'flex', alignItems:'center', gap:12, padding:'12px 0', borderBottom:'1px solid #f9fafb' }}>
                  <span style={{ fontSize:24 }}>{d.nome_original?.toLowerCase().endsWith('.pdf')?'📄':'🖼'}</span>
                  <div style={{ flex:1 }}><div style={{ fontSize:14 }}>{d.nome_original}</div></div>
                </div>
              ))
          )}
        </div>
      </div>
    </>}
  </>)
}
